import { Chip, Stack } from "@mui/material";
import { CustomTypesChannelFilter } from "../channel";

interface ChatChannelTypeFilterProps {
  customTypesFilter: CustomTypesChannelFilter;
  onFilterChange: (filterValue: CustomTypesChannelFilter) => void;
  isStarredProfessionalEnabled: boolean;
  isPlacementsEnabled: boolean;
}

export function ChatChannelTypeFilter({
  customTypesFilter,
  onFilterChange,
  isStarredProfessionalEnabled,
  isPlacementsEnabled,
}: ChatChannelTypeFilterProps) {
  return (
    <Stack
      direction="row"
      spacing={1}
      sx={{
        padding: 1,
        overflowX: "auto",
        flexWrap: "nowrap",
      }}
    >
      <Chip
        label="All"
        variant="outlined"
        color={customTypesFilter === "all" ? "primary" : "default"}
        clickable
        onClick={() => {
          onFilterChange("all");
        }}
      />
      {isPlacementsEnabled && (
        <>
          <Chip
            label="Flex"
            variant="outlined"
            color={customTypesFilter === "flex" ? "primary" : "default"}
            clickable
            onClick={() => {
              onFilterChange("flex");
            }}
          />
          <Chip
            label="Hiring"
            variant="outlined"
            color={customTypesFilter === "placements" ? "primary" : "default"}
            clickable
            onClick={() => {
              onFilterChange("placements");
            }}
          />
        </>
      )}
      {isStarredProfessionalEnabled && (
        <>
          <Chip
            label="Starred"
            variant="outlined"
            color={customTypesFilter === "starred" ? "primary" : "default"}
            clickable
            onClick={() => {
              onFilterChange("starred");
            }}
          />
        </>
      )}
    </Stack>
  );
}
